<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add A Part</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form :valid.sync="valid" class="modal-card-body">

          <article 
            v-if="parts.length == 0" 
            class="message is-info is-fullwidth">
            <div class="message-body">
              <span>
                No additional cut sheet parts are available for this project
              </span>
              <span class="help">
                Note: Only parts that require assembly, and are not 
                already in an assembly sheet are listed
              </span>
            </div>
          </article>

          <template v-else>
            <div class="field">
              <label class="label">Project Parts</label>
              <v-select
                required
                class="is-fullwidth"
                item-text="part_no"
                item-value="id"
                :options="parts"
                v-model="partId"
              />
            </div>

            <div class="field">
              <label class="label">Section</label>
              <v-text-field
                required
                placeholder="Enter part assembly details"
                v-model="section">
              </v-text-field>
            </div>
          </template>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click="addNewPart()">
            Save
          </button>
          <button class="button" @click="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    assemblySheetId: {
      type: [String, Number],
      required: true
    },
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  components: { VSelect, VTextField, VForm },
  data() {
    return {
      valid: false,
      partId: null,
      section: null,
      parts: []
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("assembly", ["addPart"]),
    initialize() {
      this.$http.cutsheetParts.get(
        { 
          project_id: this.projectId, 
          per_page: 1000,
          without_assembly: true
        }
      ).then(
        resp => this.getPartsSuccess(resp.data.results)
      );
    },
    getPartsSuccess(data) {
      this.parts = data.filter(
        d => Object.values(d.steps).map(d => d.name).indexOf('Assembly') != -1
      );
    },
    close() {
      this.$emit('input', false);
    },
    addNewPart() {
      this.addPart({ 
        assemblySheetId: this.assemblySheetId, 
        data: { cutsheetpart_id: this.partId, section: this.section }
      }).then(() => this.close());
    }
  }
}
</script>